// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.css';
import './styles/responsive.css';
import './styles/coalition.css';
import './styles/presets.css'; // Add this new import
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);